import { Injectable } from '@angular/core';
import { ConstantsService } from '../constants.service';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class RefreshFrameHelperService {
  constructor(private constants: ConstantsService) { }

  InitRefreshFrameElement(refreshFrame: HTMLIFrameElement) {
    let refreshFrameElement = document.getElementById(this.constants.HtmlElementNames.RefreshFrameId);
    
    if (!refreshFrameElement) {
      refreshFrame = this.createRefreshFrame();
      document.body.appendChild(refreshFrame);
      console.debug("Added refresh frame", refreshFrame);
    } else {
      refreshFrame = <HTMLIFrameElement>refreshFrameElement;
      console.debug("Refresh frame", refreshFrame);
    }

    return refreshFrame;
  }

  ClearRefreshFrameElement() {
    let refreshFrameElement = document.getElementById(this.constants.HtmlElementNames.RefreshFrameId);

    if (refreshFrameElement) {
      refreshFrameElement.remove();
      console.log('refreshFrame element removed');
    } 
    else {
      console.log('can not remove refreshFrame element since it is not defined');
    }
  }

  private createRefreshFrame(): HTMLIFrameElement {
    let frame = document.createElement("iframe");
    frame.setAttribute('id', this.constants.HtmlElementNames.RefreshFrameId);
    frame.style.width = "1px";
    frame.style.visibility = 'hidden';
    frame.style.height = "1px";
    frame.setAttribute('width', "1");
    frame.setAttribute('height', "1");

    return frame;
  }
}
